// extracted by mini-css-extract-plugin
export default {"spin":"Spin_spin__ZCINZ ald-spin"};